import { useContext, useState } from 'react';
import {
  NotificationOptions,
  ProfileDisplayProps,
} from '../interface/interface';
import Toggle from './ToggleComponent';
import { Tooltip } from './Tooltip';
import { UserContext } from '../context/userContext';

export const ProfileDisplay = (props: ProfileDisplayProps) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);
  const [showPushTooltip, setShowPushTooltip] = useState<boolean>(false);
  const { nativeView } = useContext(UserContext);

  const getNotificationDisabledText = (enabledStatus: boolean) => {
    if (enabledStatus) {
      return 'Disabling this option will stop all notifications from being sent.';
    }
    return 'Enabling this option will activate notifications for the Patient.';
  };

  return (
    <div className="flex justify-between items-center flex-col lg:flex-row">
      <div className="flex items-center flex-col lg:flex-row justify-center lg:justify-start">
        <div className="w-20 h-20 bg-secondary-pink-400 rounded-full flex items-center justify-center">
          <p className="text-3xl text-primary-blue-500 font-bold">
            {props.intial}
          </p>
        </div>
        <p className="lg:ml-6 text-2xl xl:text-3xl text-primary-blue-500 font-bold">
          {props.name}
        </p>
      </div>
      <div className="flex items-center justify-between sm:mt-3">
        <div className="flex items-center justify-between me-3">
          <Toggle
            label={nativeView ? 'Email' : 'Email Notification'}
            value={props.isNotificationEnabled}
            onToggle={(val) => {
              props.toggleHandler(val);
              props.notificationType(NotificationOptions.EMAIL);
            }}
            readonly={false}
          />
          <div
            className="relative ml-3 cursor-pointer"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            {showTooltip && (
              <Tooltip
                className="-right-9 sm-land:right-0 !w-[200px] !md:w-[520px] lg:!w-max break-words"
                text={getNotificationDisabledText(props.isNotificationEnabled)}
                key={'email-tooltip'}
              />
            )}
            <i
              className="fa fa-question-circle-o text-primary-blue-500"
              aria-hidden="true"
            ></i>
          </div>
        </div>
        {nativeView ? (
          <div className="flex items-center justify-between">
            <Toggle
              label={nativeView ? 'Push' : 'Push Notification'}
              value={props.isPushNotificationEnabled}
              onToggle={(val) => {
                props.togglePushHandler(val);
                props.notificationType(NotificationOptions.PUSH);
              }}
              readonly={false}
            />
            <div
              className="relative ml-3 cursor-pointer"
              onMouseEnter={() => setShowPushTooltip(true)}
              onMouseLeave={() => setShowPushTooltip(false)}
            >
              {showPushTooltip && (
                <Tooltip
                  className="right-0 !w-[200px] !md:w-[520px] lg:!w-max break-words"
                  text={getNotificationDisabledText(
                    props.isPushNotificationEnabled,
                  )}
                  key={'push-tooltip'}
                />
              )}
              <i
                className="fa fa-question-circle-o text-primary-blue-500"
                aria-hidden="true"
              ></i>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};
